import { UserState } from "../store/reducers/loginReducer";
import { Roles } from "../utils/role";
import { NavigateFunction } from 'react-router-dom';

const IMPERSONATING_FLAG = "impersonating";
const IMPERSONATED_USER = "impersonatedUser";

export const isImpersonating = (): boolean =>
  localStorage.getItem(IMPERSONATING_FLAG) === "true";

export const getImpersonatedUser = (): Partial<MasterCustomer> | null => {
  try {
    const raw = localStorage.getItem(IMPERSONATED_USER);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const toLoginUser = (customer: MasterCustomer): UserState => ({
  _id: customer._id || "",
  zohoCustomerId: customer.zohoCustomerId || "",
  firstName: customer.firstName || "",
  lastName: customer.lastName || "",
  email: customer.email || "",
  role: Roles.CUSTOMER,
  contactOwnerUserId: "",
  steps: "",
  solarStudyInvite: false,
  Contact_Group: customer.contactGroupType || "",
  purlDocuments: customer.purlDocuments || false,
});


const SESSION_KEYS = ["token", "user", "folderId"];

const clearSession = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem(IMPERSONATING_FLAG);
  localStorage.removeItem(IMPERSONATED_USER);
};

export const startImpersonation = (token: string, user: MasterCustomer) => {
  clearSession();
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(toLoginUser(user)));
  localStorage.setItem(IMPERSONATING_FLAG, "true");
  localStorage.setItem(IMPERSONATED_USER, JSON.stringify(user));

  const dashboardId = user.uniqueId || user.zohoCustomerId;
  window.location.href = `/dashboard/${dashboardId}`;
};

export const exitImpersonation = (navigate: NavigateFunction) => {
  clearSession();
  navigate('/users', { replace: true });
};
